import styled from 'foundations-theming/utils';
import { Link } from 'foundations-components/transitional/components/Link';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { Banner } from 'foundations-components/transitional/components/Banner';
import { Media, MediaBody, MediaRight } from 'foundations-components/transitional/components/Media';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { LockedIcon } from 'foundations-assets/icons/components/LockedIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Title = styled.span.withConfig({
  displayName: "TimelineUpgradePoint__Title",
  componentId: "kvdz8g-0"
})(["font-weight:", ";"], ({
  theme
}) => theme.typography['heading-600'].fontWeight);
const TimelineUpgradePoint = ({
  loading
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal('activity-limit-upgrade-point');
  if (loading) {
    return null;
  }
  const titleText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "timeline.activityLimitUpgrade.title"
  });
  const subtext = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "timeline.activityLimitUpgrade.subtitle"
  });
  const button = /*#__PURE__*/_jsx(Link, {
    onClick: openUpgradeModal,
    external: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "timeline.activityLimitUpgrade.upgrade"
    })
  });
  return /*#__PURE__*/_jsx(Banner, {
    role: "alert",
    "data-test-id": "activity-limit-upgrade-point",
    marginInline: "400",
    children: /*#__PURE__*/_jsxs(TFlex, {
      flexDirection: "row",
      alignItems: "center",
      align: "center",
      gap: 8,
      rowGap: "25",
      flexWrap: "wrap",
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsx(LockedIcon, {
          size: "600",
          color: "icon-core-default"
        })
      }), /*#__PURE__*/_jsx(Title, {
        role: "heading",
        children: titleText
      }), /*#__PURE__*/_jsx(TFlex, {
        flex: "1 1 380px",
        minInlineSize: "0",
        children: /*#__PURE__*/_jsxs(Media, {
          children: [/*#__PURE__*/_jsx(MediaBody, {
            children: /*#__PURE__*/_jsx(Paragraph, {
              textWrap: "nowrap",
              margin: "0",
              children: subtext
            })
          }), /*#__PURE__*/_jsx(MediaRight, {
            align: "end",
            children: button
          })]
        })
      })]
    })
  });
};
export default TimelineUpgradePoint;